module.exports = __webpack_public_path__ + "img/record-videos-coursifyme.edccea70.jpeg";